import React from 'react';
import { MaintenanceConfig, Splits } from '../../types/split.type';
import { Modal } from 'react-bootstrap';
import { ImageMaintenance } from '../../assets/images';
import { TranslationUtils } from '../../utils';
import { Button } from '../Button/Button';
import './MaintenanceModal.scss';
import { useFeatureConfig } from '../../services/optimizely/optimizelyHelper';

export const MaintenanceModal: React.FC = () => {
    const { isEnabled: isMaintenanceEnabled, config: maintenanceConfig } = useFeatureConfig<MaintenanceConfig>(
        Splits.GUESTS_PORTAL_MAINTENANCE,
        true
    );
    const handleClose = () => null;

    const shouldShowErrorModal = isMaintenanceEnabled && maintenanceConfig && maintenanceConfig.full;

    return (
        <Modal id={'error-modal'} backdropClassName={'custom-modal-backdrop'} show={shouldShowErrorModal ?? false} onHide={handleClose}>
            <Modal.Header />
            <Modal.Body className={'error-modal-body'}>
                <br />
                <br />
                <ImageMaintenance className="maintenance-modal-image" />
                <div className="error-modal-instructions">
                    <br />
                    <h4 className={'heading-med-light'}>{TranslationUtils.get('maintenance_window_title')}</h4>
                    <div className="mb-4" />
                    <p className={'body-regular'}>{TranslationUtils.get('maintenance_window_note')}</p>
                </div>
                <div className="early-checkout-modal-buttons">
                    <br />
                    <a
                        aria-label={`${TranslationUtils.get('maintenance_go_to_home')}`}
                        href={TranslationUtils.get('maintenance_link')}
                        className={'body-regular'}
                    >
                        <Button
                            id="button-cancel-checkout"
                            className="body-regular maintenance-action-button"
                            onClick={handleClose}
                            label={TranslationUtils.get('maintenance_go_to_home')}
                            variant="primary"
                            block
                        />
                    </a>
                </div>
            </Modal.Body>
        </Modal>
    );
};
